import Dialog from '@/components/dialog/Dialog';
import DialogHeader from '@/components/dialog/DialogHeader';
import { useModal } from '@ebay/nice-modal-react';
import { PrimaryButtonMTV2 } from '../../../components/buttons/Buttons';
import '../views/concierge.styles.css'
import { Controller, Resolver, useForm } from 'react-hook-form';
import { Column, Row } from '@/components/container/Container';
import { TextHeadlineExtraSmall } from '@/components/text/Texts';
import { SelectCountryIconDropdownConcierge } from '@/components/form-inputs/select-country/SelectCountryIconDropdown';
import { Flag } from '@/modules/authentication/sign-up/components/CountryFlags';
import Spacing from '@/components/container/Spacing';
import { mixed, object, string } from 'yup';
import { VALIDATION_MESSAGES } from '@/constants/validation';
import { yupResolver } from '@hookform/resolvers/yup';
import { PassengerDto } from '@/modules/vehicle/engine/ActivityTypes';
import { PhoneHelper } from '@/common/PhoneHelper';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { InputController } from '@/components/inputs/InputController';
import TextInput from '@/components/inputs/TextInput';

export const schema = object({
	FirstName: string().trim().required(VALIDATION_MESSAGES.required)
		.test('no-numbers', 'Names cannot contain numbers', function (value) {
			if (!value) return true; // Let required validation handle empty values
			return !/\d/.test(value);
		}),
	LastName: string().trim().required(VALIDATION_MESSAGES.required)
		.test('no-numbers', 'Names cannot contain numbers', function (value) {
			if (!value) return true; // Let required validation handle empty values
			return !/\d/.test(value);
		}),
	Phone: string().trim().required(VALIDATION_MESSAGES.required)
		.test('is-valid-phone', 'Please enter a valid phone number', function (value) {
			if (!value) return true; // Let required validation handle empty values
			try {
				const countryCode = this.parent.mobileNumberPrefix || 'PH';
				const prepared = PhoneHelper.preparePhoneNumber(value, countryCode);
				const res = isValidPhoneNumber(prepared, countryCode);
				return res;
			} catch (error) {
				// If validation fails, return false
				return false;
			}
		}),
	Country: mixed<Flag>().optional(),
});

type Props = {
	//Id: number;
};

const AddPassengerDialog = (props: Props) => {

	const formId = 'AddPassengerForm';
	const form = useForm<PassengerDto>({
		resolver: yupResolver(schema) as unknown as Resolver<PassengerDto>,
		mode: 'all'
	});

	const modal = useModal();


	const onSubmit = async (data: PassengerDto) => {
		let toSend: PassengerDto = { ...data, Phone: PhoneHelper.preparePhoneNumber(data.Phone!, data.Country?.code || 'PH') }
		modal.resolve(toSend);
		modal.remove();
	};


	return (
		<Dialog
			className="x4b-concierge text-body-large font-poppins"
			style={{ width: '544px' }}
			header={
				<DialogHeader title="Add Passenger" />
			}
			visible={true}
			onHide={() => {
				modal.remove();
			}}
		>
			<form>
				<Spacing height='h-6'></Spacing>
				<Column>
					<TextHeadlineExtraSmall text='Who’s Riding?' className="text-primary font-medium" />
					<Spacing height='h-3'></Spacing>
					<Row className="gap-2">
						<InputController id="FirstName" control={form.control}>
							<TextInput variant="outlined" label="First Name" />
						</InputController>
						<InputController id="LastName" control={form.control}>
							<TextInput variant="outlined" label="Last Name" />
						</InputController>
					</Row>
					<Spacing height='h-6'></Spacing>
					<TextHeadlineExtraSmall text='Telephone' className="text-primary font-medium" />
					<Spacing height='h-3'></Spacing>
					<Row className="gap-2">
						<Controller
							name={'Country'}
							control={form.control}
							defaultValue={{ name: 'Philippines', code: 'PH', dialCode: '+63' } as Flag}
							render={({ field, fieldState: { error } }) => (
								<SelectCountryIconDropdownConcierge
									value={field.value}
									onChange={field.onChange}
									className="max-h-14"
								/>
							)}
						/>
						<InputController id="Phone" control={form.control}>
							<TextInput variant="outlined" label="Phone Number" keyfilter="num" />
						</InputController>
					</Row>
					<Spacing height='h-11'></Spacing>
					<div className="flex w-full gap-4">
						<PrimaryButtonMTV2
							id="add-passenger-submit"
							type="submit"
							label={"Add Passenger"}
							disabled={!form.formState.isValid}
							className='w-full'
							onClick={form.handleSubmit(onSubmit)}
						/>
					</div>
				</Column>
			</form>
		</Dialog>
	);
};

export default AddPassengerDialog;
